import * as ex from "excalibur";
import { CONFIG } from "../config";
const DUST_BEGIN_COLOR = ex.Color.fromRGB(196, 172, 132, 0.8);
const DUST_END_COLOR = ex.Color.fromRGB(196, 172, 132, 0);
const PARTICLE_LIFE_MS = 700;
// Marks a tile under construction with a small looping dust puff while we wait for the
// placement to round-trip through the server and arrive back over SSE (see GameScene's
// handleTilePlacement/addBuildingActor). Emits from a small rectangle centered on the tile so
// puffs scatter across the base footprint rather than from a single point.
export class BuildDustEffect {
    emitter;
    stopped = false;
    constructor(scene, tile) {
        const w = CONFIG.TILE_WIDTH * 0.4;
        const h = CONFIG.TILE_HEIGHT * 0.4;
        this.emitter = new ex.ParticleEmitter({
            // Rectangle emitters spawn within [0,width]x[0,height] of pos, not centered on it.
            pos: tile.center.add(ex.vec(-w / 2, -h / 2)),
            width: w,
            height: h,
            emitterType: ex.EmitterType.Rectangle,
            emitRate: 14,
            particle: {
                life: PARTICLE_LIFE_MS,
                fade: true,
                beginColor: DUST_BEGIN_COLOR,
                endColor: DUST_END_COLOR,
                minSize: 2,
                maxSize: 4,
                minSpeed: 8,
                maxSpeed: 18,
                // Upward cone with spread (screen-space: angle 0 = +x, +y is down, so "up" is -PI/2).
                minAngle: -Math.PI / 2 - 0.6,
                maxAngle: -Math.PI / 2 + 0.6,
                acc: ex.vec(0, -6),
            },
        });
        // Draw above ground and any neighboring buildings — this is a short-lived overlay.
        this.emitter.z = tile.get(ex.TransformComponent).pos.y + 1e6;
        scene.add(this.emitter);
    }
    // Stops spawning new particles; already-emitted ones finish fading out on their own.
    // Safe to call more than once.
    stop() {
        if (this.stopped)
            return;
        this.stopped = true;
        this.emitter.isEmitting = false;
        setTimeout(() => this.emitter.kill(), PARTICLE_LIFE_MS);
    }
}
